module.exports = __webpack_public_path__ + "assets/img/emergencyContact.8f5450e3.png";